import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Button';
import HeaderImage from './header.svg';
import './FreelancerTooManyCreatorsPopup.css';

export const FreelancerTooManyCreatorsPopup = ({
  handleEditSelections,
  handleFinish,
}) => (
  <div className="many-creators-popup">
    <img
      className="many-creators-popup__header"
      alt="header"
      src={HeaderImage}
    />
    <div className="many-creators-popup__title">
      You&apos;ve Selected Too Many Creators
    </div>
    <div className="many-creators-popup__description">
      We&apos;d want to hire all of our awesome creators too, but let&apos;s
      have you select
      <br />
      your top 5 choices.
    </div>
    <div className="many-creators-popup__action">
      <Button
        className="many-creators-popup__action--edit-selections"
        flat
        rounded
        bordered
        title="Edit selections"
        onClick={handleEditSelections}
      />
      <Button
        className="many-creators-popup__action--finish"
        rounded
        title="Finish"
        onClick={handleFinish}
      />
    </div>
  </div>
);

FreelancerTooManyCreatorsPopup.propTypes = {
  handleEditSelections: PropTypes.func,
  handleFinish: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Popup/FreelancerTooManyCreatorsPopup/FreelancerTooManyCreatorsPopup.js